import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { toast } from './toasts';

/** navigate() after a successful write, with a success toast ("Subjekt bol uložený."); `state.focus`: see RouteFocus. */
export function useNavigateWithToast() {
  const navigate = useNavigate();
  return useCallback(
    (to: string, text: string, state?: { focus?: string }) => {
      toast.success(text);
      void navigate(to, state ? { state } : undefined);
    },
    [navigate],
  );
}
